<app-banner [heading]="'CLUB SCHEDULE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">

	<!-- ======= About Section ======= -->
	<section id="about" class="about">

		<div class="container">
			<div class="row">

				<div class="col-lg-12 col-md-6">
					<p class="heading2">CLUB SYLLABUS FOR THE NEW SESSION 2021-22</p>
					<!-- ======= Table Section ======= -->
					<table class="table table-hover">
						<thead>
							<tr>
								<th width="5%">S.NO.</th>
								<th width="70%">Club</th>
								<th width="25%">DOWNLOAD</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th scope="row">1</th>
								<td>Albert Einstein Club( I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1obKMg1ilngsLTNzqQkBaJvxNvD8Z5GLi/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">2</th>
								<td>Albert Einstein Club( VI to VIII) </td>
								<td class=""><a
										href="https://drive.google.com/file/d/1lsem8OfLdYGlJ8wPmXYcrYUf9G9ZYerR/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">3</th>
								<td>Eco Club ( I to VIII ) </td>
								<td class=""><a 
									href="https://drive.google.com/file/d/1BpQKcggp9asjjYPDgZUPPQ6Aio-YfU9h/view?usp=sharing" 
									target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>
							<tr>
								<th scope="row">4</th>
								<td>Home Science Club ( I to VIII)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1kCnqIm1TLSBAGHE1WPz0PPenE68wXBoI/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>
							<!-- <tr>
								<th scope="row">3</th>
								<td>Vedic Math Club(I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/18UiKY2rkA4g8V4pGAn3IiRmxutvti-sV/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>
							<tr>
								<th scope="row">4</th>
								<td>Vedic Math Club(VI to VIII) </td>
								<td class=""><a
										href="https://drive.google.com/file/d/1A080dVaTaGPlWPNHTKv4bpiHMLtsuJ1k/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr> -->
							
							<tr>
								<th scope="row">5</th>
								<td>Public Speaking Club( I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1aUNfj7N7IT56Fc3tk5akv6uaPkM2etmQ/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">6</th>
								<td>Public Speaking Club ( VI to VIII)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1eQOOLh7IvbeF5oL8zn-trhrorC5cs0ic/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>
							
							<tr>
								<th scope="row">7</th>
								<td>Quiz Club ( I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1HeEpn8dkmlLGrwXD8DeVXzSzXiTVKhZV/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">8</th>
								<td>Quiz Club ( VI to VIII) </td>
								<td class=""><a
										href="https://drive.google.com/file/d/1nMLB5cw5793YVnMXvUWQ0AEbohhlxoBj/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">9</th>
								<td>I.T Club ( I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/18noABGvZ1_pS55NFiPviwbcPrpa87mNn/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">10</th>
								<td>I.T Club ( VI to VIII)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1fOwdd8bIZPF01LJyHGc_qxWpdSH5VVgp/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">11</th>
								<td>Dramatics Club ( I to VIII)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1eHqaWqdugUiSYrDhdHevK_n_VgcdrIAB/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">12</th>
								<td>Art and Craft Club( I to V)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1o6b0Qz3HvzccMEC9xmOXxjS8EGvQnHkZ/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">13</th>
								<td>Art and Craft Club (VI to VIII)</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1TTMbzN4f17pMLFUDYqcxvzX7qhdzqfM4/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>							
							
							<tr>
								<th scope="row">14</th>
								<td>Sports club (I to VIII )</td>
								<td class=""><a
										href="https://drive.google.com/file/d/1nJU3Afvs0HhEnWbwbsFvqxw6Uva4-4eK/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>

							<tr>
								<th scope="row">15</th>
								<td>Dance club (I to VIII )</td>
								<td class=""><a
										href="https://drive.google.com/file/d/18VzLeCiQ9NhGPX37GIzoI7qSIqrx76Ow/view?usp=sharing"
										target="_blank">VIEW &amp; DOWNLOAD</a></td>

							</tr>
						</tbody>
					</table>

				</div>


			</div>
		</div>
	</section><!-- End About Section -->

</main>